<template>
  <div class="tile-container">
    <div id="voucher-modal" class="modal fade">
      <div class="modal-dialog modal-lg">
        <div class="modal-content" v-if="shown === true">
          <ValidationObserver v-slot="{ invalid }">
            <div class="modal-header">
              <modal-close-button-new @confirmed="closeModal" />
              <h4 class="modal-title">
                {{ form.id ? $t("global.edit") : $t("global.new") }}
                {{ $t("global.voucher") }}
              </h4>
            </div>

            <div
              class="modal-body table-wrapper"
              style="max-height: 1000px; height: 35vh"
            >
              <div class="row">
                <div class="col-xl-6">
                  <div class="form-group">
                    <ValidationProvider
                      :rules="form.id ? '' : 'required'"
                      v-slot="{ passed }"
                    >
                      <input
                        v-model.trim="form.token"
                        class="form-control"
                        :disabled="!!form.id"
                        v-bind:class="{ 'border-danger': !passed && !form.id }"
                      />
                      <label
                        v-bind:class="{ 'text-danger': !passed && !form.id }"
                      >
                        {{ $t("global.token") }}<span v-if="!form.id">*</span>
                      </label>
                      <small v-if="form.id" class="text-muted"> </small>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="col-xl-6">
                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      immediate
                      v-slot="{ errors }"
                    >
                      <input
                        type="date"
                        class="form-control"
                        v-model="gueltigBisDate"
                        :class="{ 'border-danger': errors.length > 0 }"
                      />
                      <label :class="{ 'text-danger': errors.length > 0 }">
                        {{ $t("global.validuntil") }} ({{ $t("global.date") }})*
                      </label>
                    </ValidationProvider>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-xl-6">
                  <div class="form-group">
                    <ValidationProvider
                      rules="required|min_value:0"
                      immediate
                      v-slot="{ errors }"
                    >
                      <input
                        type="number"
                        class="form-control"
                        v-model.number="form.kontigent"
                        min="0"
                        :class="{ 'border-danger': errors.length > 0 }"
                      />
                      <label :class="{ 'text-danger': errors.length > 0 }">
                        {{ $t("global.contingent") }}*
                      </label>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="col-xl-6">
                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      immediate
                      v-slot="{ errors }"
                    >
                      <v-select
                        v-model="form.status_id"
                        :options="statusOptions"
                        label="bezeichnung"
                        :reduce="(s) => s.id"
                        :placeholder="$t('global.status')"
                        :class="{ 'border-danger': errors.length > 0 }"
                      >
                        <span slot="no-options">{{
                          $t("global.nodataavailable")
                        }}</span>
                      </v-select>

                      <label :class="{ 'text-danger': errors.length > 0 }">
                        {{ $t("global.status") }}*
                      </label>
                    </ValidationProvider>
                  </div>
                </div>
              </div>

              <div class="row" v-if="form.id">
                <div class="col-xl-12">
                  <small class="text-muted">
                    {{ $t("global.usedCodes") }}:
                    {{ original.verwendete_codes ?? "-" }},
                    {{ $t("global.availableCodes") }}:
                    {{ original.verfuegbare_codes ?? "-" }}
                  </small>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div>
                <button
                  v-if="form.id"
                  type="button"
                  class="btn btn-danger"
                  :disabled="isBusy"
                  @click="requestDelete"
                >
                  {{ $t("global.delete") }}
                </button>

                <button
                  type="button"
                  class="btn btn-default"
                  @click="closeModal"
                >
                  {{ $t("global.close") }}
                </button>

                <button
                  type="button"
                  class="btn btn-primary"
                  :disabled="invalid || isBusy"
                  @click="uebernehmen"
                >
                  {{ $t("global.apply") }}
                </button>
              </div>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalCloseButtonNew from "@/components/global/ModalCloseButtonNew";
import page from "@/mixins/Page";

export default {
  name: "VoucherModal",
  components: { ModalCloseButtonNew },
  mixins: [page],
  props: {
    isBusy: { type: Boolean, default: false },
    firma: { type: Object, default: null },
    statusOptions: { type: Array, default: () => [] },
  },
  data() {
    return {
      shown: false,

      // original = VoucherDTO (für Anzeige used/available)
      original: {},

      // form = Formdaten für POST/PUT
      form: {
        id: null,
        token: "",
        gueltigBis: null,
        kontigent: null,
        status_id: null,
      },

      // Date input helper (YYYY-MM-DD)
      gueltigBisDate: null,
    };
  },
  mounted() {
    this.$bus.$on("voucher-modal-show", (data) => {
      // CREATE
      if (data?.neu) {
        this.original = {};
        this.form = {
          id: null,
          token: "",
          gueltigBis: null,
          kontigent: null,
          status_id: this.statusOptions?.[0]?.id ?? null,
        };

        this.gueltigBisDate = null;
      } else {
        // EDIT: data ist VoucherDTO
        this.original = { ...data };
        this.form = {
          id: data.id,
          token: data.token || "",
          gueltig_bis: data.gueltig_bis || null,
          kontigent: data.verwendete_codes + data.verfuegbare_codes || null,
          status_id: data.status_id || null,
        };

        // Date-Input befüllen
        this.gueltigBisDate = this.toYmdDate(data.gueltig_bis);
      }

      if (!this.shown) this.openModal();
    });
  },
  methods: {
    openModal() {
      this.shown = true;
      $("#voucher-modal").modal({ backdrop: "static", keyboard: false });
    },
    closeModal() {
      this.shown = false;
      this.original = {};
      this.form = {
        id: null,
        token: "",
        gueltig_bis: null,
        kontigent: 0,
        status_id: null,
      };
      this.gueltigBisDate = null;
      $("#voucher-modal").modal("hide");
    },

    toYmdDate(value) {
      if (!value) return null;

      const d = new Date(Number(value));
      if (isNaN(d.getTime())) return null;

      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");

      return `${yyyy}-${mm}-${dd}`;
    },

    ymdToEpochMillis(ymd) {
      if (!ymd) return null;

      const [yyyy, mm, dd] = ymd.split("-").map(Number);

      // UTC Mitternacht erzeugen (verhindert Zeitzonenverschiebung)
      return Date.UTC(yyyy, mm - 1, dd, 0, 0, 0);
    },

    uebernehmen() {
      // gueltigBis aus Date-Input bauen
      this.form.gueltigBis = this.ymdToEpochMillis(this.gueltigBisDate);

      if (!this.form.id) {
        // POST: VoucherPostRequestDTO
        this.$emit("voucherCreated", { ...this.form });
      } else {
        // PUT: VoucherPutRequestDTO
        this.$emit("voucherChanged", { ...this.form });
      }
      this.closeModal();
    },

    requestDelete() {
      if (!this.form?.id) return;
      this.$emit("voucherDeleted", this.form.id);
      this.closeModal();
    },
  },
};
</script>

<style scoped>
[class^="col-"],
[class*="col-"] {
  padding-right: 15px !important;
  padding-left: 15px !important;
}
</style>
